export const MODAL_TYPE_POSTING_DISABLED = 'posting-disabled';
